import BsnSetupList from './BsnSetupList';
export default BsnSetupList;
